// extracted by mini-css-extract-plugin
export default {"navLink":"NavBar_navLink__Cy4UW","image":"NavBar_image__JVEVC"};